import { from, Observable } from 'rxjs';
import { TranslateLoader }  from '@ngx-translate/core';

export class ImportLoader implements TranslateLoader {
    getTranslation ( lang: string ): Observable<any> {
      return from(import(`../../lang/locale-${lang}.json`)
      .then(res => res.default));
    }
}